// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._28CVdunVDDpuRyepdlykXS a {\n    text-decoration: none;\n    color: inherit;\n  }", ""]);
// Exports
exports.locals = {
	"listItem": "_28CVdunVDDpuRyepdlykXS"
};
module.exports = exports;
